module.exports = __webpack_public_path__ + "img/ic_launcher.3a98ed77.png";